import React, { FC } from 'react';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { map, some, findIndex } from 'lodash';
import { useField, FieldArray } from 'formik';
import { RejectWeldSubReason } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { ListSelectionStyled } from '@bechtel/client-common';
import { Comment } from '../comment';
import { SubReason, SubReasonListProps } from './types';
import { SendBackSubReasonMessages } from '~/components/atoms';

export const SubReasonList: FC<SubReasonListProps> = ({ name, subReasonList, showComment, onSelectionChange }) => {
  const [field, meta] = useField(name);
  const { i18n } = useLingui();
  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="sub-reason-list-container">
      <FieldArray name={name}>
        {(arrayHelpers) => {
          return (
            <>
              {map(subReasonList, (subReason) => {
                return (
                  <ListSelectionStyled
                    key={subReason.value}
                    data-testid={`sub-reason-item-${subReason?.label}`}
                    onClick={() => {
                      const selected = findIndex(field?.value, (item: SubReason) => {
                        return item.value === subReason?.value;
                      });
                      if (selected !== -1) {
                        arrayHelpers.remove(selected);
                      } else {
                        arrayHelpers.push(subReason);
                      }
                      if (!onSelectionChange) return;
                      onSelectionChange(field?.value);
                    }}
                  >
                    <Box mr={{ sm: '500' }}>
                      <Checkbox
                        checked={some(field?.value, (item: SubReason) => {
                          return item.value === subReason.value;
                        })}
                        readOnly
                      />
                    </Box>
                    {subReason?.label && (
                      <Text size="400" color="grey.1000">
                        {i18n._(SendBackSubReasonMessages[subReason.label])}
                      </Text>
                    )}
                    {RejectWeldSubReason.OTHER_SUB_REASON === subReason.label && (
                      <Box pl={{ sm: '200' }}>
                        <Text size="300" color="grey.600">
                          <Trans>(Comment Required)</Trans>
                        </Text>
                      </Box>
                    )}
                  </ListSelectionStyled>
                );
              })}
            </>
          );
        }}
      </FieldArray>
      {showComment && <Comment name="subReasonComment" />}
    </Box>
  );
};
